import axios from "../api";
import { objectToParam } from "../../libs/utils";

export async function getDrivers(companyId, params = {}) {
  const parameters = objectToParam(params);
  const { data } = await axios.get(
    `/companies/${companyId}/drivers?${parameters}`
  );
  return data;
}
